import { Component, Input, Output, EventEmitter, HostListener, AfterViewInit, ChangeDetectorRef, OnInit } from '@angular/core';
import { IProductOrderItem } from '../../models/product-order-item';
import { OOESessionService } from '../../../../../../../../libs/core-ui/src/lib/services/ooe-session.service';
import { Store } from '@ngrx/store';
import { CoreUiPartialState, getArbCentralNavSecurity } from '@pos-app/core-ui';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-product-add-to-order',
    templateUrl: './product-add-to-order.component.html',
    styleUrls: ['./product-add-to-order.component.scss'],
    standalone: false
})
export class ProductProductAddToOrderComponent implements OnInit, AfterViewInit {
  @Input() public product: IProductOrderItem;
  @Input() public hasAssociatedItemWarning: boolean;
  @Input() public totalPrice: number;
  @Input() public currencyCode: string;
  @Input() public readOnlyEPCTF: boolean;
  @Input() public selectedItemCount = 0;
  @Input() public includeParent = true;

  @Output() public addedToOrder = new EventEmitter();
  @Output() public updatedQuantity = new EventEmitter();
  @Output() public addToOrderInProgress = new EventEmitter();
  @Output() public includeParentChange = new EventEmitter<boolean>();

  public addToOrderClicked = false;
  public top: any = 75;
  arbCentralSecurityFunctions$: Observable<boolean>;

  public get isUserloggedIn(): boolean {
    return this.ooeSessionService.loginedSession != null;
  }

  constructor(
    private ooeSessionService: OOESessionService,
    private changeDetectorRef: ChangeDetectorRef,
    private coreUiStore: Store<CoreUiPartialState>,
  ) {}

  public ngOnInit(): void {
    this.arbCentralSecurityFunctions$ = this.coreUiStore.select(getArbCentralNavSecurity);
  }
  public addToOrder(): void {
    if (this.addToOrderClicked) {
      this.addToOrderInProgress.emit();
      return;
    } 
    console.log('Clicked add to order state');
    this.addToOrderClicked = true;
    this.addedToOrder.emit();
  }

  public resetAddToOrderState(): void {
    console.log('Resetting add to order state');
    this.addToOrderClicked = false;
  }

  public hasValidOrderTypes(): boolean {
    const session = JSON.parse(localStorage.getItem('jdeSession'));
    var returnV = true;
    if (!session || !session.ValidOrderTypes || session.ValidOrderTypes.length <= 0) returnV = false;
    return returnV;
  }

  public updateQuantity(): void {
    this.updatedQuantity.emit();
  }

  public ngAfterViewInit(): void {
    // adjust top position base on product-summary height
    this.onWindowScroll();
  }

  @HostListener('window:scroll', ['$event'])
  public onWindowScroll(event?: Event) {
    let element = document.getElementById('product-summary-section');
    let summaryHeight = element.clientHeight;
    this.top = summaryHeight;
    this.changeDetectorRef.detectChanges();
  }
}
